import React, { useState, useEffect } from "react";
import moment from "moment";
import TripServices from "../../services/externalServices/trip/TripServices";
import { useLocation } from "react-router-dom";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentFailure from "./components/PaymentFailure";
import sendToWhatsApp from "../../utils/functions/WhatsAppUtils";

const BookingStatus = () => {
  const [tripData, setTripData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const location = useLocation();
  const tripId = location.state?.tripId; // Get tripId from state


  console.error("tripId",tripId)
  useEffect(() => {
    if (tripId) {
      fetchTripDetails(tripId);
    }
  }, [tripId]);

  const fetchTripDetails = async (id) => {
    try {
      setIsLoading(true);
      const res = await TripServices.getTripByIdPopulateAllData(id);
      console.log("TripServices TripServices",res)
      setTripData(res.trip);
      setSelectedDate(
        res.trip?.bid?.cab_request?.tripDate
          ? moment(res.trip.bid.cab_request.tripDate)
          : null
      );
      setSelectedTime(
        res.trip?.bid?.cab_request?.tripTime
          ? moment(res.trip.bid.cab_request.tripTime)
          : null
      );

      setIsSuccess(
        res.trip?.paymentDetails?.state === "COMPLETED" &&
        (res.trip?.paymentDetails?.responseCode === "SUCCESS"|| res.trip?.paymentDetails?.responseCode === "PAYMENT_SUCCESS")
      );
    } catch (err) {
      console.error("Error fetching trip details:", err);
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendMessage = (messageType) => {
    sendToWhatsApp(messageType, tripId, "", "", "");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      {isLoading ? (
        <div className="text-center">
          <div className="animate-spin h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
          <p className="text-gray-700 mt-2">Loading...</p>
        </div>
      ) : (
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg">
          {isSuccess ? (
            <PaymentSuccess
              packageName={tripData?.tripTitle}
              selectedDate={selectedDate}
              selectedTime={selectedTime}
              rider={tripData?.rider}
              tripId={tripId}
              handleSendMessage={handleSendMessage}
            />
          ) : (
            <PaymentFailure
            tripId={tripId}
            rider={tripData?.rider}
            cabRequestId={tripData?.bid?.cab_request?.id || tripData?.bid?.cab_request?._id}
            isAutoBid={tripData?.bid?.cab_request?.isAutoBid === true}
              packageName={tripData?.tripTitle}
              selectedDate={selectedDate}
              selectedTime={selectedTime}
              handleSendMessage={handleSendMessage}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default BookingStatus;
